import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { Icon, Typography, InputGroup } from '../';
import { Menubar } from 'primereact/menubar';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { MultiSelect } from 'primereact/multiselect';
import { addLocale } from 'primereact/api';
import moment from 'moment';

addLocale('pt', {
  firstDayOfWeek: 1,
  dayNames: ["domingo", "segunda", "terça", "quarta", "quinta", "sexta", "sábado"],
  dayNamesShort: ["dom", "seg", "ter", "qua", "qui", "sex", "sáb"],
  dayNamesMin: ["dom", "seg", "ter", "qua", "qui", "sex", "sáb"],
  monthNames: ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"],
  monthNamesShort: ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"],
  today: 'Hoje',
  clear: 'Limpar'
});

const StudyListFilter = ({
  filtersMeta,
  filterValues,
  onChange,
  clearFilters,
  isFiltering,
  numOfStudies,
}) => {
  const { t } = useTranslation('StudyList');
  const { sortBy, sortDirection } = filterValues;
  const filterSorting = { sortBy, sortDirection };
  const setFilterSorting = sortingValues => {
    onChange({
      ...filterValues,
      ...sortingValues,
    });
  };
  const isSortingEnabled = numOfStudies > 0 && numOfStudies <= 100;

  const [pacienteNome, setPacienteNome] = useState(filterValues.patientName);
  const [prontuario, setProntuario] = useState(filterValues.mrn);
  const [acNumber, setAcNumber] = useState(filterValues.accession);
  const [dataInicial, setDataInicial] = useState(filterValues.studyDate.startDate ? moment(filterValues.studyDate.startDate).toDate() : new Date());
  const [dataFinal, setDataFinal] = useState(filterValues.studyDate.endDate ? moment(filterValues.studyDate.endDate).toDate() : new Date());
  const [modalidade, setModalidade] = useState(filterValues.modalities);
  const [descricao, setDescricao] = useState(filterValues.description);

  const formatDate = (date) => {
    try {
      if (date) {
        const _date = moment(date).format('YYYYMMDD');
        return _date;
      }
    } catch (ex) { }
    return date;
  }

  const buscar = () => {
    onChange(
      {
        ...filterValues,
        patientId: prontuario,
        patientName: pacienteNome,
        accessionNumber: acNumber,
        startDate: formatDate(dataInicial),
        endDate: formatDate(dataFinal),
        modalitiesInStudy: modalidade,
        studyDescription: descricao
      }
    )
  }

  const onKeyEnter = (e) => {
    if (e.key.toLowerCase() === 'enter')
      buscar();
  }

  const monthNavigatorTemplate = (e) => {
    return <Dropdown
      value={e.value}
      options={e.options}
      onChange={(event) => e.onChange(event.originalEvent, event.value)}
      className="mr-10 inputTextFilter"
      style={{ lineHeight: 1 }}
    />;
  }

  const yearNavigatorTemplate = (e) => {
    return <Dropdown
      value={e.value}
      options={e.options}
      onChange={(event) => e.onChange(event.originalEvent, event.value)}
      className="inputTextFilter"
      style={{ lineHeight: 1 }}
    />;
  }

  return (
    <>
      <Menubar style={{ border: 'solid 1px #3f4b5b', background: '#2a323d', borderRadius: '0', padding: '30px 15px 30px 15px' }} start={
        <div className='card'>
          <div className='flex p-fluid'>
            <div className='mr-10' style={{ width: '250px' }}>
              <label>Paciente</label><br />
              <InputText
                id='patientName'
                value={pacienteNome}
                className='inputTextFilter'
                onChange={e => setPacienteNome(e.target.value)}
                onKeyUp={e => onKeyEnter(e)}
              />
            </div>
            <div className='mr-10' style={{ width: '150px' }}>
              <label>Prontuário</label><br />
              <InputText
                id='mrn'
                value={prontuario}
                className='inputTextFilter'
                onChange={e => setProntuario(e.target.value)}
                onKeyUp={e => onKeyEnter(e)}
              />
            </div>
            <div className='mr-10' style={{ width: '150px' }}>
              <label>AcNumber</label><br />
              <InputText
                value={acNumber}
                id='accession'
                className='inputTextFilter'
                onChange={e => setAcNumber(e.target.value)}
                onKeyUp={e => onKeyEnter(e)}
              />
            </div>
            <div className='mr-10' style={{ width: '150px' }}>
              <label>Data Inicial</label><br />
              <Calendar
                id="startDate"
                showIcon
                locale={'pt'}
                dateFormat="dd/mm/yy"
                mask={'99/99/9999'}
                value={dataInicial} onChange={e => setDataInicial(e.value)}
                monthNavigator yearNavigator yearRange={`2000:${moment().format('YYYY')}`}
                monthNavigatorTemplate={monthNavigatorTemplate}
                yearNavigatorTemplate={yearNavigatorTemplate}
                showButtonBar
              />
            </div>
            <div className='mr-10' style={{ width: '150px' }}>
              <label>Data Final</label><br />
              <Calendar
                id="endDate"
                showIcon locale={'pt'}
                dateFormat="dd/mm/yy"
                mask={'99/99/9999'}
                value={dataFinal} onChange={e => setDataFinal(e.value)}
                monthNavigator yearNavigator yearRange={`2000:${moment().format('YYYY')}`}
                monthNavigatorTemplate={monthNavigatorTemplate}
                yearNavigatorTemplate={yearNavigatorTemplate}
                showButtonBar
              />
            </div>
            <div className='mr-10'>
              <label>Modalidade</label><br />
              <MultiSelect value={modalidade} options={[
                { name: 'CR', value: 'CR' },
                { name: 'CT', value: 'CT' },
                { name: 'DO', value: 'DO' },
                { name: 'DX', value: 'DX' },
                { name: 'MR', value: 'MR' },
                { name: 'OT', value: 'OT' },
                { name: 'PR', value: 'PR' },
                { name: 'PT', value: 'PT' },
                { name: 'RX', value: 'RX' },
                { name: 'SC', value: 'SC' },
                { name: 'SR', value: 'SR' },
                { name: 'US', value: 'US' },
                { name: 'XA', value: 'XA' }
              ]} onChange={(e) => setModalidade(e.value)} optionLabel="name" placeholder="Selecionar" maxSelectedLabels={5} className='inputTextFilter' scrollHeight="500px" />

            </div>
            <div className='mr-10' style={{ width: '300px' }}>
              <label>Descrição</label><br />
              <InputText
                value={descricao}
                id='description'
                className='inputTextFilter'
                onChange={e => setDescricao(e.target.value)}
                onKeyUp={e => onKeyEnter(e)}
              />
            </div>
            <div>
              <label style={{ visibility: 'hidden' }}>.</label><br />
              <Button icon='pi pi-search' label='Buscar' onClick={() => buscar()} />
            </div>
          </div>
        </div>
      }></Menubar>
    </>
  );
};

StudyListFilter.propTypes = {
  filtersMeta: PropTypes.arrayOf(
    PropTypes.shape({
      /** Identifier used to map a field to it's value in `filterValues` */
      name: PropTypes.string.isRequired,
      /** Friendly label for filter field */
      displayName: PropTypes.string.isRequired,
      /** One of the supported filter field input types */
      inputType: PropTypes.oneOf(['Text', 'MultiSelect', 'DateRange', 'None'])
        .isRequired,
      isSortable: PropTypes.bool.isRequired,
      /** Size of filter field in a 12-grid system */
      gridCol: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12])
        .isRequired,
      /** Options for a "MultiSelect" inputType */
      option: PropTypes.arrayOf(
        PropTypes.shape({
          value: PropTypes.string,
          label: PropTypes.string,
        })
      ),
    })
  ).isRequired,
  filterValues: PropTypes.object.isRequired,
  numOfStudies: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  clearFilters: PropTypes.func.isRequired,
  isFiltering: PropTypes.bool.isRequired,
};

export default StudyListFilter;
